```vue
<template>
<div class="buysell-overlay" @click.self="dismiss()">
<div class="card centered fix_dim" ref="draggableContainer" id="draggable-container">
    <div class="card-body">
    <div class="card-title" id="draggable-header" @mousedown="dragMouseDown"> {{ $store.state.buySellData.displayName }}
      <div class="right-align">
        <label class="switch">
         <input type="checkbox" v-model="type">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <h6 class="card-subtitle mb-2 text-muted">₹ {{ $store.state.ticker[$store.state.buySellData.instrumentToken]}}</h6>
    <hr class="mt-1 mb-1"/>
    <div class="form-check form-check-inline">
        <input class="form-check-input radio" :class="type ? 'radio-red' : 'radio-blue'" v-model="orderDuration" value="MIS" type="radio" name="orderDuration" id="MIS" checked>
         <label class="form-check-label radio-font-size" for="MIS">
           Intraday <span class="text-muted">MIS</span>
          </label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input radio" :class="type ? 'radio-red' : 'radio-blue'" v-model="orderDuration" value="CNC" type="radio" name="orderDuration" id="CNC">
         <label class="form-check-label radio-font-size" for="CNC">
           Longterm <span class="text-muted">CNC</span>
          </label>
    </div>
    <div class="row mt-2 g-2">
      <div class="did-floating-label-content col-6 col-sm-4">
        <input class="did-floating-input" type="number" placeholder=" " v-model="qty" :step="step" min="0">
        <label class="did-floating-label">Qty</label>
      </div>
      <div class="did-floating-label-content col-6 col-sm-4">
        <input class="did-floating-input" v-model="price" :class="orderType == 'MKT' || orderType == 'SL' ? 'disabled' : ''" type="number" placeholder=" " :disabled="orderType == 'MKT' || orderType == 'SL'" min="0">
        <label class="did-floating-label" :class="orderType == 'MKT' || orderType == 'SL' ? 'disabled' : ''">Price</label>
      </div>
      <div class="did-floating-label-content col-6 col-sm-4">
        <input class="did-floating-input" v-model="triggerPrice" :class="orderType == 'MKT' || orderType == 'LIMIT' ? 'disabled' : ''" type="number" placeholder=" " :disabled="orderType == 'MKT' || orderType == 'LIMIT'" min="0">
        <label class="did-floating-label" :class="orderType == 'MKT' || orderType == 'LIMIT' ? 'disabled' : ''">Trigger Price</label>
      </div>
    </div>
    <div class="d-flex flex-wrap gap-3 mt-2">
      <div class="form-check">
        <input class="form-check-input radio" :class="type ? 'radio-red' : 'radio-blue'" v-model="orderType" value="MKT" type="radio" name="orderType" id="market">
         <label class="form-check-label radio-font-size" for="market">
           Market
          </label>
      </div>
      <div class="form-check">
        <input class="form-check-input radio" :class="type ? 'radio-red' : 'radio-blue'" v-model="orderType" value="LIMIT" type="radio" name="orderType" id="limit">
         <label class="form-check-label radio-font-size" for="limit">
           Limit
          </label>
      </div>
      <div class="form-check">
        <input class="form-check-input radio" :class="type ? 'radio-red' : 'radio-blue'" v-model="orderType" value="SL" type="radio" name="orderType" id="sl">
         <label class="form-check-label radio-font-size" for="sl">
           SL
          </label>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="btn btn-outline-secondary button-box" @click="dismiss()">Cancel</button>
      <button type="button" class="btn button-box" @click="placeOrder()" :class="type ? 'btn-danger' : 'btn-primary'" :disabled="isDisabled">
        <span v-if="!isDisabled">{{ type ? "Sell" : "Buy" }}</span>
        <span v-if="isDisabled" class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
        <span v-if="isDisabled" role="status">{{ type ? "Selling..." : "Buying..." }}</span>
      </button>
    </div>
  </div>
</div>
</div>
</template>

<script>
import { buysell, getPositions, getHoldings, buysellModify } from '@/service/restService'
export default {
  name: 'BuySell',
  data: function () {
    return {
      positions: {
        clientX: null,
        clientY: null,
        movementX: 0,
        movementY: 0
      },
      orderType: this.$store.state.buySellData.orderType ? this.$store.state.buySellData.orderType : 'MKT',
      orderDuration: this.$store.state.buySellData.duration ? this.$store.state.buySellData.duration : (localStorage.getItem('prev_duration_' + this.$store.state.buySellData.displayName.split(' ')[0]) ? localStorage.getItem('prev_duration_' + this.$store.state.buySellData.displayName.split(' ')[0]) : 'MIS'),
      qty: this.$store.state.buySellData.qty ? this.$store.state.buySellData.qty : (localStorage.getItem('prev_qty_' + this.$store.state.buySellData.displayName.split(' ')[0]) ? localStorage.getItem('prev_qty_' + this.$store.state.buySellData.displayName.split(' ')[0]) : this.$store.state.buySellData.lotSize),
      type: this.$store.state.buysell !== 'BUY',
      step: this.$store.state.buySellData.lotSize,
      price: this.$store.state.buySellData.price ? this.$store.state.buySellData.price : 0,
      triggerPrice: this.$store.state.buySellData.triggerPrice ? this.$store.state.buySellData.triggerPrice : 0,
      modifyId: this.$store.state.buySellData.modifyId ? this.$store.state.buySellData.modifyId : 0,
      isDisabled: false
    }
  },
  created () {
    this.$store.watch(
      (state, getters) => getters.buysell,
      (newValue, oldValue) => {
        this.type = this.$store.state.buysell !== 'BUY'
        this.qty = this.$store.state.buySellData.lotSize
        this.step = this.$store.state.buySellData.lotSize
      }
    )
  },
  watch: {
    orderType: function (value, oldValue) {
      if (value === 'LIMIT') {
        this.price = this.$store.state.ticker[this.$store.state.buySellData.instrumentToken]
        this.triggerPrice = 0
      } else if (value === 'MKT') {
        this.price = 0
        this.triggerPrice = 0
      } else if (value === 'SL') {
        this.price = 0
        this.triggerPrice = this.$store.state.ticker[this.$store.state.buySellData.instrumentToken]
      }
    }
  },
  methods: {
    getPositions: function () {
      getPositions().then((response) => {
        this.$store.commit('updatePosition', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    getHoldings: function () {
      getHoldings().then((response) => {
        this.$store.commit('updateHolding', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    dragMouseDown: function (event) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      this.$refs.draggableContainer.style.top = (this.$refs.draggableContainer.offsetTop - this.positions.movementY) + 'px'
      this.$refs.draggableContainer.style.left = (this.$refs.draggableContainer.offsetLeft - this.positions.movementX) + 'px'
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },
    dismiss () {
      this.$store.commit('closeBuySell', '')
    },
    showError (msg) {
      this.$store.commit('addToast', {
        title: 'Failure!',
        type: 'error',
        message: msg
      })
    },
    placeOrder () {
      if (this.qty <= 0) {
        this.showError('Invalid quantity, Please enter quantity greater than 0')
        return
      }
      if (this.step > 0 && (this.qty % this.step) !== 0) {
        this.showError('Invalid quantity, Please enter quantity based on lot size')
        return
      }
      if (this.qty >= 10000) {
        this.showError('Invalid quantity, Please enter quantity lesser than 10000')
        return
      }
      if (this.step === 0) {
        this.showError('Non tradable instrument, Please choose tradable instrument')
        return
      }
      if (this.orderType === 'SL' && this.triggerPrice <= 0) {
        this.showError('Invalid trigger quantity, Please enter trigger quantity greater than 0')
        return
      }
      if (this.orderType === 'LIMIT' && this.price <= 0) {
        this.showError('Invalid price, Please enter LIMIT price greater than 0')
        return
      }
      if (this.type === false && this.orderType === 'SL' && this.triggerPrice <= this.$store.state.ticker[this.$store.state.buySellData.instrumentToken]) {
        this.showError('Invalid trigger Price, Please enter trigger price greater than current price')
        return
      }
      if (this.type === true && this.orderType === 'SL' && this.triggerPrice >= this.$store.state.ticker[this.$store.state.buySellData.instrumentToken]) {
        this.showError('Invalid trigger Price, Please enter trigger price lesser than current price')
        return
      }
      var postfix = this.$store.state.buySellData.displayName.split(' ')[0]
      localStorage.setItem('prev_qty_' + postfix, this.qty)
      localStorage.setItem('prev_duration_' + postfix, this.orderDuration)
      var buySellObject = {
        'instrumentToken': this.$store.state.buySellData.instrumentToken,
        'qty': this.qty,
        'type': this.type ? 'SELL' : 'BUY',
        'duration': this.orderDuration,
        'price': this.price,
        'triggerPrice': this.triggerPrice,
        'orderType': this.orderType
      }
      this.isDisabled = true

      if (this.modifyId !== 0) {
        buysellModify(buySellObject, this.modifyId).then((response) => {
          this.$store.commit('removeMyOpenOrder', this.modifyId)
          if (response.data.status === 'COMPLETE') {
            this.isDisabled = false
            this.getPositions()
            this.getHoldings()
            this.getUserView()
            this.$store.commit('addExecutedOrder', response.data)
            this.$store.commit('addToast', {
              title: 'Success!',
              type: 'success',
              message: 'Order executed Successfully for ' + response.data.instrumentName
            })
          } else if (response.data.status === 'PENDING') {
            this.isDisabled = false
            this.$store.commit('addOpenOrder', response.data)
            this.$store.commit('addToast', {
              title: 'Pending!',
              type: 'info',
              message: 'Order pending for ' + response.data.instrumentName
            })
          }
          this.dismiss()
        }).catch((error) => {
          this.isDisabled = false
          this.$store.commit('addToast', {
            title: 'Failure!',
            type: 'error',
            message: error.response.data.message[0]
          })
        })
      } else {
        buysell(buySellObject).then((response) => {
          if (response.data.status === 'COMPLETE') {
            this.isDisabled = false
            this.getPositions()
            this.getHoldings()
            this.getUserView()
            this.$store.commit('addExecutedOrder', response.data)
            this.$store.commit('addToast', {
              title: 'Success!',
              type: 'success',
              message: 'Order executed Successfully for ' + response.data.instrumentName
            })
          } else if (response.data.status === 'PENDING') {
            this.isDisabled = false
            this.$store.commit('addOpenOrder', response.data)
            this.getUserView()
            this.$store.commit('addToast', {
              title: 'Pending!',
              type: 'info',
              message: 'Order pending for ' + response.data.instrumentName
            })
          }
          this.dismiss()
        }).catch((error) => {
          this.isDisabled = false
          this.$store.commit('addToast', {
            title: 'Failure!',
            type: 'error',
            message: error.response.data.message[0]
          })
        })
      }
    }
  }
}
</script>

<style>
.buysell-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Mobile screens (up to 480px) */
@media only screen and (max-width: 480px) {
  .centered {
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .fix_dim {
    width: 90vw;
    min-width: unset;
    max-width: unset;
    box-sizing: border-box;
  }
  .button-box {
    min-width: 80px;
    flex: 1;
  }
}

/* Tablets (up to 768px) */
@media only screen and (min-width: 481px) and (max-width: 768px) {
  .fix_dim {
    min-width: 25rem;
    max-width: 30rem;
    box-sizing: border-box;
  }
}

/* Desktops (769px and above) */
@media only screen and (min-width: 769px) {
  .fix_dim {
    min-width: 20rem;
    max-width: 25rem;
    box-sizing: border-box;
  }
}

#draggable-container {
  position: fixed;
  z-index: 1001;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  background-color: var(--bs-body-bg);
}

#draggable-header {
  z-index: 10;
  cursor: grab;
}

.right-align {
  margin-top: 6px;
  display: inline;
  float: right;
}

.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0d6efd;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 0.5px;
  bottom: 2.5px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #DC4C64;
}

input:focus + .slider {
  box-shadow: 0 0 1px #0d6efd;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.radio {
  appearance: none;
  border-color: grey;
}

.radio-red:checked {
  background-color: #DC4C64;
}

.radio-blue:checked {
  background-color: #0d6efd;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.form-check .radio-inline {
  vertical-align: top;
}

.radio-font-size {
  font-size: 14px;
}

.button-box {
  min-width: 100px;
  height: 35px;
}

.did-floating-label {
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 11px;
  padding: 0 5px;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  top: -8px;
  font-size: 13px;
}

.did-floating-label-content {
  position: relative;
  margin-bottom: 10px;
  min-width: 0;
}

.did-floating-input, .did-floating-select {
  font-size: 12px;
  display: block;
  width: 100%;
  height: 36px;
  padding: 0 20px;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
  box-sizing: border-box;
  outline: none;
}

.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}

.disabled {
  background-color: var(--bs-secondary-bg);
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/order/BuySell.vue